import React, {useState,useEffect} from 'react';

const ItemInfoPopUp = props =>{
        // props:
	// data, see below
	// scrim:false turns scrim off. can also be in data
	// centered:false turns off auto centering of popup-body
	// style is style json that gets applied to popup-body
	// instant:true turns off cleanup phase and intro animations

    
	const [cleanup, setCleanup] = useState(false)
	console.log(props)
	const data = props.data || {
		scrim:true,
		header:'Error',
		body:"Popup data prop not provided",
		button:"button"
	}

	const handleButtonClick = () => {
		setCleanup(true);
		setTimeout(()=> {
			if(props.onClose) props.onClose();
			if(props.onComplete) props.onComplete();
		}, (props.instant === true ? 0 : 600))
	
	}

	const getAnimationClasses = () => {
		if(props.instant === true) return '';
		return cleanup ? 'cleanup' : 'not-cleanup'
	}

	return (
		<div className={`ItemInfoPopup Popup ${getAnimationClasses()} ${props.class || ''} ${props.centered === false ? 'not-centered' : 'centered'} `}>
			<div className="popup-body" style={props.style || {}}>
            <div className={`close-button`} onClick={handleButtonClick}>X</div>
				<div className={`content`} dangerouslySetInnerHTML={{__html:props.data.additionalInfo}} />
                
			</div>
		</div>
	)
}

export default ItemInfoPopUp;